import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import ReduxUseRecord from '../../../../store/actionreducers/useRecord';
import ReduxCallHelper from '../../../../store/actionreducers/callHelper';
import {FusePageSimple} from '../../../../@fuse/index';
import UseRecordList from './UseRecordList';
import UecareAlertDialog from "../../../../components/UecareAlertDialog";
import UecareListHeader from "../../../../components/header/UecareListHeader";

class MedicalUseRecordApp extends Component {

    async componentDidMount() {
        try {
            const medicalId = this.props.match.params.medicalId;
            const medical = await this.props.getMedical(medicalId);
            await this.props.getUseRecordsByUserId(medical.user.id);
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                    }}
                    header={
                        <UecareListHeader
                            title='點數紀錄'
                            icon='search'
                            arrowBack={{
                                linkTo: '/apps/medical',
                                label: '合作夥伴列表'
                            }}/>
                    }
                    content={
                        <UseRecordList/>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />
                <UecareAlertDialog/>
            </React.Fragment>
        )
    };
}

const styles = theme => ({
    root: {},
    avatar: {},
    layoutHeader: {
        height: 160,
        minHeight: 160
    },
    layoutContentCardWrapper: {
        padding: 24,
        paddingBottom: 80
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMedical: ReduxCallHelper.ActionCreator.getMedical,
        getUseRecordsByUserId: ReduxUseRecord.ActionCreator.getUseRecordsByUserId,
    }, dispatch);
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(null, mapDispatchToProps)(MedicalUseRecordApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/useRecord/MedicalUseRecordApp.js